import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, Row, Col, Input, Tabs, Divider } from 'antd';
import CommentsList from './CommentsList';
import {
  getCommentForARequest,
  addCommentForARequest
} from '../../services/api/comments';
import { setCommentClosed, setChatOpened } from '../../actions';

const { TabPane } = Tabs;
const { TextArea } = Input;

class CommentsDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: this.props.requestId ? true : false,
      activeTab: '1',
      networkComments: [],
      internalComments: [],
      networkCenterName: null,
      doctorName: null,
      loading: true,
      savingComment: false
    };
    console.log(props, 'Props for comments Dialog');
  }

  componentDidMount() {
    this.fetchComments();
    this.setLastSeenOnComment();
  }

  componentWillUnmount() {
    this.props.dispatch(setCommentClosed());
  }

  setLastSeenOnComment = () => {
    this.props.dispatch(
      setChatOpened({
        lastReadTime: new Date().getTime() * 10000,
        requestId: this.props.requestId
      })
    );
  };

  //
  toggleDialog = () => {
    this.props.dispatch(setCommentClosed());
  };

  saveComment = () => {
    const { newComment } = this.state;
    console.log(newComment, 'NEw comment');
    if (newComment && newComment.trim().length === 0) {
      return;
    }
    if (this.state.savingComment) {
      return;
    }
    this.setState({ savingComment: true });
    const type = this.state.activeTab === '1' ? 'network' : 'internal';
    addCommentForARequest(this.props.requestId, newComment.trim(), type)
      .then(() => getCommentForARequest(this.props.requestId))
      .then(response => {
        this.setState({
          networkCenterName: response.body.requestInfo.networkCenterName,
          doctorName: response.body.requestInfo.doctorName,
          networkComments: response.body.networkComments,
          internalComments: response.body.internalComments,
          newComment: '',
          savingComment: false
        });
      })
      .catch(err => {
        console.log(err);
        this.setState({ savingComment: false });
      });
  };

  toggleTab = tab => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  };

  fetchComments = () => {
    getCommentForARequest(this.props.requestId)
      .then(response => {
        console.log('Response', response);
        this.setState({
          networkCenterName: response.body.requestInfo.networkCenterName,
          doctorName: response.body.requestInfo.doctorName,
          networkComments: response.body.networkComments,
          internalComments: response.body.internalComments,
          loading: false
        });
      })
      .catch(err => {
        console.error('Error in fetching', err);
      });
  };

  render() {
    return (
      <Modal
        title="Comments"
        visible={this.state.modal}
        onCancel={this.toggleDialog}
        onOk={this.toggleDialog}>
        <Row>
          <Col span={8} className="col">
            <h5>RequestId: {this.props.requestId}</h5>
          </Col>
          <Col span={8} className="col">
            <h5>NC: {this.state.networkCenterName}</h5>
          </Col>
          <Col span={8} className="col">
            <h5>DoctorName: {this.state.doctorName}</h5>
          </Col>
        </Row>

        <Tabs
          defaultActiveKey="1"
          onChange={key => this.setState({ activeTab: key })}>
          <TabPane key="1" tab="Network">
            {this.state.loading ? (
              <h4>Loading</h4>
            ) : (
              <CommentsList comments={this.state.networkComments} />
            )}
          </TabPane>
          <TabPane key="2" tab="Internal">
            {this.state.loading ? (
              <h4>Loading</h4>
            ) : (
              <CommentsList comments={this.state.internalComments} />
            )}
          </TabPane>
        </Tabs>
        <Divider />
        <Row>
          <Row>
            <Col>
              <Row>
                <TextArea
                  maxLength={'255'}
                  id="comment"
                  rows="3"
                  value={this.state.newComment}
                  onChange={e => this.setState({ newComment: e.target.value })}
                />
                <Button onClick={this.saveComment}>Send</Button>
              </Row>
            </Col>
          </Row>
        </Row>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return { requestId: state.comments.requestId };
}

export default connect(mapStateToProps)(CommentsDialog);
